import { useMemo } from 'react';

import { useGET } from './useGET';

const toUrl = (leagueId, seasonId) => {
  return `/stages?league=${leagueId || ''}&season=${seasonId || ''}`;
};

export default function useStages(leagueId, seasonId) {
  const url = toUrl(leagueId, seasonId);
  const data = useGET(url);

  return useMemo(() => data && data.results, [data]);
}
